export default function useFeatureFlags() {
  const {
    public: { featureFlags },
  } = useRuntimeConfig()

  function isFeatureEnabled(flag: keyof typeof featureFlags) {
    return !!featureFlags[flag]
  }

  return {
    isFeatureEnabled,
  }
}
